import { CngProductDTO } from "./cng-product";
import { GenericConfig } from '@signature-it/ngx-generic/config';
import {PhoneWithPrefix} from "./forms/phone-with-prefix";

export class CngDataDTO  {
    ans: object = {};
    calc: object = {};
    fcc: any[];
    product: CngProductDTO;
	quantity: number;
	product_id: number;
	protected readonly defaultFields = ['ans_titles', 'id'];

    constructor(product: CngProductDTO | any, formFcc: any, ans: object, formFields: any, calc: object) {
    	this.setFcc(formFcc);
    	this.setAns(ans || {}, formFields);
		this.product = product instanceof CngProductDTO ? product: CngProductDTO.create(product);
		this.calc = calc;
		this.product_id = product && product.id ? product.id : -1;
    }


    setFcc(formFcc: any) {
		this.fcc = formFcc.map(_fcc => {
			return {
				key: _fcc.fieldName,
				value: _fcc.value,
				tag: _fcc.tag
			};
		});
    }

    setAns(ans: object, formFields: any) {
		Object.keys(ans).forEach((key) => {
			const currentField = formFields.find(field => field.key == key);
			if(!currentField && GenericConfig.debugMode ) {
				if(this.defaultFields.indexOf(key) > -1 ) return;
				console.log('WARNING! the field ' + key + ' not found in form');
				return;
			}
			if(!currentField || currentField.ignoreInAns) return;
			this.ans[key] = ans[key];
			if (currentField.options && Array.isArray(currentField.options) && currentField.options.length && this.ans[key] && !(currentField instanceof PhoneWithPrefix)) {
				if (currentField.isMultiple) {
					this.ans[key] = {
						isMultiple: true,
						data: currentField.options.filter(opt => ans[key].includes(opt.key) || ans[key].includes(opt.value)),
					};
				} else {
					this.ans[key] = currentField.options.find(opt => opt.key == ans[key] || opt.value == ans[key]);
				}
				if(!this.ans[key] || this.ans[key].isMultiple && !this.ans[key].data.length || !currentField.attrForAns) {
					console.log('WARNING! the field ' + key + ' answer not found in options');
					return;
				}
				this.ans[key]['includePrice'] = currentField.attrForAns['includePrice'] || this.ans[key]['includePrice'];
				this.ans[key]['includeBom'] = currentField.attrForAns['includeBom'] || this.ans[key]['includeBom'];
			}
		});
	}

	fetchProduct(cngProductId: number, productId: number) {
		this.product.cngProductId = cngProductId;
		this.product.product_pic = `/${GenericConfig.imagesPath}/${GenericConfig.systemName}/Prod_pic/${cngProductId}/${this.getProdPic()}`,
		this.product.product_code = this.getPcc();
		this.product.id = productId;
	}

	getPcc() {
		return this.fcc.find(item => {
			return item['tag'] === 'pcc';
		}).value;
	}

	getProdPic() {
        const cngProdutPicFccTag = GenericConfig.cngProdutPicFccTag || 'image';
		const tag = this.fcc.find(item => {
            return item['tag'] === cngProdutPicFccTag;
        });
        return tag != undefined ? tag.value: "";
	}

	getPrice() {
    	let price = 0;
		Object.keys(this.ans).forEach((key) => {
			price += this.ans[key]['includePrice']? this.ans[key]['price']: 0;
		});
    	return price;
    }
}


